import { Divider, styled, Typography } from '@material-ui/core';

import { COLORS } from 'theme/constants';

export const BillingPlansDescription = styled(Typography)({
  fontSize: '14px',
  color: COLORS.cozmosPurple4,
  whiteSpace: 'pre-line',
});

export const StyledDivider = styled(Divider)({
  margin: '10px 10px 10px 10px',
});
